import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../../../theme/generated/tokens.css';
import '../lib/styles.css';
import './portal.css';
import { App } from './App.tsx';
import { lesKonfig } from './konfig.ts';
import { lagSesjon, taInvitasjonFraFragment, taTokenFraFragment } from './sesjon.ts';

/**
 * Oppstart: konfig fra bygget, tokenet ut av fragmentet FØR noe annet skjer
 * (og fragmentet bort fra URL-en), utkastet fra en avbrutt innsending, og
 * appen. `/ny` er retur-URL-en etter ny innlogging — den er landingssiden med
 * dialogen åpen på utkastet.
 */
const konfig = lesKonfig();
// Invitasjonen FØR tokenet: begge kan ligge i samme fragment, og begge skal ut av
// adresselinja før noe rendres (DD-12).
taInvitasjonFraFragment();
taTokenFraFragment();
const sesjon = lagSesjon();
const utkast = location.pathname.startsWith('/ny') ? sesjon.hentUtkast() : null;
if (location.pathname.startsWith('/ny')) history.replaceState(null, '', '/');

createRoot(document.getElementById('rot')!).render(
  <StrictMode>
    <App konfig={konfig} sesjon={sesjon} utkast={utkast} />
  </StrictMode>,
);
